import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface EmployeeStatusResult {
  status?: string;
  loading: boolean;
  error?: string;
}

export const useEmployeeStatus = (
  username?: string,
  year?: string,
  quarter?: number
): EmployeeStatusResult => {
  const client = useMyProviderDataClient();

  const [status, setStatus] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!username || !year || quarter == null) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const res = await client.get("/EmployeeInformation/DirectoryOfCoordinator", {
          params: { username, year, quarter },
        });

        setStatus(res.data?.employeeStatus);
      } catch (err) {
        console.error(err);
        setError("Failed to load employee status.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, year, quarter, client]);

  return { status, loading, error };
};
